import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import "./plugins/vue-fontawesome";
import "./plugins/vue-mq";
import App from "./App.vue";
import router from "./router";
import VueNoty from 'vuejs-noty'
import calculate from "./calculate"

Vue.use(VueNoty, {
    timeout: 4000,
    progressBar: true,
    layout: 'bottomRight'
})
import 'vuejs-noty/dist/vuejs-noty.css'
import ProductZoomer from 'vue-product-zoomer'
Vue.use(ProductZoomer)

const axios = require('axios');
axios.defaults.baseURL = "https://backendnew.reflectionsuae.com/";
//axios.defaults.baseURL = "http://localhost:8083/";


Vue.config.productionTip = false;
Vue.prototype.$axios = axios

Vue.mixin({
    methods: {
        isUoMNumber: function (num) {

            return num && !isNaN(num.substr(num.length - 1, 1)) ? true : false;
        },
        formatMoney: function (number, decPlaces, decSep, thouSep) {
            decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
                decSep = typeof decSep === "undefined" ? "." : decSep;
            thouSep = typeof thouSep === "undefined" ? "," : thouSep;
            var sign = number < 0 ? "-" : "";
            var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
            var j = (j = i.length) > 3 ? j % 3 : 0;

            return sign +
                (j ? i.substr(0, j) + thouSep : "") +
                i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
                (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
        },
        getImageUrl: function (name) {
            if (name) {
                name = name.split(";");

                return "https://reflectionsimages.s3.ap-southeast-1.amazonaws.com/" + name[0] + ".jpg";
            }
            return "";
        },
        formatProduct: function (price) {
            return this.formatMoney(price, 2, ".", ",");

        },
        getProdPrice: function (price) {
            return this.formatMoney(calculate(price * 1.12), 2, ".", ",");
        },
        getUrl: function (name) {
            return name.toLowerCase().replace(" ", "-");
        }
    },
});
import store from "./store";


new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
